export default "__VITE_ASSET__Bw4t$yc5__"